module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_hamano-7f929d4ffe7097779d9d5b9a0d87b4bb.jpg";